import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { ProgressBar } from "react-bootstrap";
import TabFilter from "../../../components/TabFilter/TabFilter";
const CompanyRiskCard = ({ t, companyrisk, riskparamdata, callbackRisk }) => {
  const [riskType, setRiskType] = useState("Supplier");
  const filterData = [
    { name: t("Supplier.label"), value: t("Supplier.label") },
    { name: t("Company.label"), value: t("Company.label") },
  ];
  const progressBarGenerate = (item) => {
    if (item) {
      let avgScore = riskType === "Supplier" ? item?.avgScore : item?.weightedAvgScore;
      if (item?.resultType != null) {
        let colorClass = "color-" + item?.resultType?.colorCode?.replace(/^#/, "");
        return (
          
          // 
          <><ProgressBar
          now={avgScore * 10}
            // label={parseFloat(avgScore?.toFixed(1))}
            className={colorClass}
          />{(avgScore) != 0 && <span>{avgScore.toFixed(1)}</span>}</>
        );
      } else {
        return (
          <><ProgressBar
          now={avgScore * 10}
            // label={parseFloat(avgScore?.toFixed(1))}
          />{(avgScore) != 0 && <span>{avgScore.toFixed(1)}</span>}</>
        );
      }
    }
  };
  const callbackTab = (val) => {
    setRiskType(val);
    let obj = {
      configType: val
    }
    callbackRisk(obj);
  };
  return (
    <div className="card CD-Risk_02">
      <div className="CD-Risk02_header d-flex justify-content-between align-items-center">
        <strong>{t("Risk.label")}</strong>
        <div className="choose_comapny_supplier_box">
          <TabFilter data={filterData} callbackValue={callbackTab} />
        </div>
      </div>
      <div className="CD-Risk02-body p-0">

        <div className="main_SC-Risk02-view">
          {/* {riskType === "Supplier" && ( */}
          <ul>
            <li>
              <p>{t("RiskCategory.label")}</p>
              <h6 className="m-0">
                {companyrisk && companyrisk?.resultType != null && (
                  <span style={{ color: companyrisk?.resultType?.colorCode }}>
                    {companyrisk?.resultType?.resultType}
                  </span>
                )}
              </h6>
            </li>
            <li>
              <p>{t("RiskRating.label")}</p>
              <h6 className="m-0">
                {companyrisk && companyrisk?.averageScore != null && (
                  <span>
                    {companyrisk?.averageScore?.toFixed(1)}/10
                  </span>
                )}
              </h6>
            </li>
          </ul>
          {/* )} */}
        </div>

        <div className="SC-Risk_parameterView02">
          <div className="SC-RiskpView02_in">
            <ul>
              <li>
                <p className="m-0">{t("RiskParameter.label")}</p>
              </li>
              <li>
                <p className="m-0">Score (1-10)</p>
              </li>
            </ul>
          </div>
          {riskparamdata &&
            riskparamdata.map((item, idx) => (
              <div className="SC-RiskpView02_in" key={idx}>
                <ul>
                  <li>{riskType === "Supplier" ? item?.riskParamName : item?.riskParam?.name}</li>
                  <li>{progressBarGenerate(item)}</li>
                </ul>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};
export default withTranslation()(CompanyRiskCard);
